import { render, staticRenderFns } from "./AtendimentoManage.vue?vue&type=template&id=27dabad2&scoped=true"
import script from "./AtendimentoManage.vue?vue&type=script&lang=js"
export * from "./AtendimentoManage.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoManage.vue?vue&type=style&index=0&id=27dabad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dabad2",
  null
  
)

export default component.exports